import { nextTick, noop } from "@jetjs/utils";
import { Operator } from "@jetjs/streams";
class SplitOperator extends Operator {
    constructor() {
        super(noop, noop);
        this.started = false;
        this.nextObservers = [];
    }
    /**
     * subscribe to the observable and start the lazy stream
     *
     * @param observerOrNext If an Observer is provided, the following arguments will be ignored
     * @param error (optional) Error handler
     * @param complete (optional) completion handler
     */
    subscribe(observerOrNext, error, complete) {
        const subscription = super.subscribe(observerOrNext, error, complete);
        const observer = this.nextObserver;
        if (!observer) {
            throw new Error("Invalid Subscriber");
        }
        this.nextObservers.push(observer);
        this.nextObserver = undefined; // reset to accept new subscriptions
        return subscription;
    }
    next(value) {
        this.nextObservers.forEach(o => o.next(value));
    }
    error(err) {
        this.nextObservers.forEach(o => o.error(err));
    }
    complete() {
        this.nextObservers.forEach(o => o.complete());
    }
    subscribeUpstream() {
        if (!this.started) {
            // because we have to reset this.nextObserver, we have to execute upstream subscription ourself at the next tick
            this.started = true;
            nextTick(() => {
                super.subscribeUpstream();
            });
        }
    }
}
const create = () => {
    return new SplitOperator();
};
/**
 * merges the given Array of streams into one.
 *
 * @param observables to merge streams, they should contain the same type of data
 */
export const split = (...operator) => {
    // create an operator, that just passes the value to the next subscriber (or operator)
    const splitOperator = create();
    // pipe every stream into the split operator
    operator.forEach(o => splitOperator.pipe(o));
    return splitOperator;
};
//# sourceMappingURL=split.js.map